import { Token } from 'eth-mainnet-few-sdk-core-2'

export class UserAddedToken extends Token {}
export class UserAddedWrappedToken extends Token {}
